import { DateTreated } from '@/core/domain/people/Customers/Customers.types';
import { useChartTheme } from '@/hooks';
import formatterNumber from '@/utils/number/formatterNumber';
import formatterPercent from '@/utils/number/formatterPercent';
import { ResponsivePie } from '@nivo/pie';
import { Card, Typography } from 'antd';

interface Props {
  dateTreated: DateTreated;
  baseColor: string[];
}

export default function CustomerQuantityPercentagePie({
  dateTreated,
  baseColor,
}: Props) {
  const [maleColor, femaleColor, unspecifiedColor] = baseColor;
  const theme = useChartTheme();
  const sumQuantity =
    (dateTreated?.maleCustomersCount || 0) +
    (dateTreated?.genderUnspecifiedCustomersCount || 0) +
    (dateTreated?.femaleCustomersCount || 0);

  return (
    <Card style={{ borderRadius: 4 }}>
      <Typography.Title level={4} style={{ textAlign: 'center' }}>
        Cliente por gênero (%)
      </Typography.Title>
      <div style={{ height: 300 }}>
        <ResponsivePie
          margin={{ top: 24, right: 100, bottom: 48, left: 100 }}
          sortByValue={true}
          innerRadius={0.5}
          padAngle={1}
          cornerRadius={4}
          activeOuterRadiusOffset={8}
          enableArcLabels={false}
          arcLinkLabelsSkipAngle={15}
          arcLinkLabel={(item) =>
            `${item.label}: ${formatterPercent(item.value / sumQuantity)}`
          }
          arcLinkLabelsColor={{ from: 'color' }}
          colors={({ data }) => data.color}
          valueFormat={(value) => formatterPercent(value / sumQuantity)}
          data={[
            {
              id: 'Homens',
              label: `Homens`,
              color: maleColor,
              value: formatterNumber(dateTreated?.maleCustomersCount || 0),
            },
            {
              id: 'Mulheres',
              label: `Mulheres`,
              color: femaleColor,
              value: formatterNumber(dateTreated?.femaleCustomersCount || 0),
            },
            {
              id: 'Não especificados',
              label: `Não especificados`,
              color: unspecifiedColor,
              value: formatterNumber(
                dateTreated?.genderUnspecifiedCustomersCount || 0,
              ),
            },
          ]}
          legends={[
            {
              anchor: 'bottom',
              direction: 'row',
              justify: false,
              translateX: 0,
              translateY: 48,
              itemsSpacing: 0,
              itemWidth: 150,
              itemHeight: 18,
              itemDirection: 'left-to-right',
              itemOpacity: 1,
              symbolSize: 18,
              symbolShape: 'circle',
            },
          ]}
          theme={theme}
        />
      </div>
    </Card>
  );
}
